/**
 * Core site metadata for the Data Chimp Labs brand experience.
 * Translation: Core site metadata for the Data Chimp Labs brand experience.
 */
export const siteMetadata = {
  siteName: "Data Chimp Labs",
  baseUrl: "https://datachimplabs.com",
  defaultTitle:
    "Kanzi | Private AI for Healthcare by Data Chimp Labs",
  defaultDescription:
    "Kanzi is a private AI with persistent memory that runs on your healthcare " +
    "organization's infrastructure — learning how you operate and running the work that matters. " +
    "Live in weeks. Data never leaves your walls.",
  defaultKeywords: [
    "private ai healthcare",
    "persistent ai memory",
    "enterprise ai platform",
    "hipaa compliant ai",
    "healthcare automation",
    "ai workflow automation",
    "clinical ai",
    "healthcare ai deployment",
    "ai for health systems",
    "kanzi ai",
  ],
  contactEmail: "contact@datachimplabs.com",
  trustCenter: {
    label: "Trust Center",
    href: "https://trust.datachimplabs.com",
    description:
      "Public compliance, security, and privacy documentation for Data Chimp Labs " +
      "and Kanzi - the Private AI for Healthcare platform",
  },
  socialImage: "/og.jpg",
  socialImageAlt:
    "Kanzi by Data Chimp Labs — Private AI for Healthcare Organizations",
  navigationLinks: [
    { id: "kanzi", label: "Kanzi", href: "/" },
    { id: "scenes", label: "Work", href: "/#scenes" },
    { id: "how-it-works", label: "How It Works", href: "/how-it-works" },
    { id: "about", label: "Team", href: "/#about" },
    { id: "blog", label: "Insights", href: "/blog" },
    { id: "about-engineering", label: "Engineering", href: "/forward-deployed-engineering" },
  ],
};

/**
 * Shared organization schema used by the SEO layer.
 * Translation: Shared organization schema used by the SEO layer.
 */
export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${siteMetadata.baseUrl}/#organization`,
  name: siteMetadata.siteName,
  url: `${siteMetadata.baseUrl}/`,
  logo: {
    "@type": "ImageObject",
    url: `${siteMetadata.baseUrl}/icons/icon.svg`,
    width: 320,
    height: 320,
  },
  image: `${siteMetadata.baseUrl}${siteMetadata.socialImage}`,
  description:
    "Kanzi is a private AI with persistent memory built for healthcare organizations. It runs on your infrastructure, learns how your business actually operates, and deploys autonomous workflows in weeks — with data that never leaves your walls.",
  email: siteMetadata.contactEmail,
  contactPoint: {
    "@type": "ContactPoint",
    email: siteMetadata.contactEmail,
    contactType: "sales",
    availableLanguage: "English",
  },
  knowsAbout: [
    "Private AI for Healthcare",
    "Persistent AI Memory Systems",
    "HIPAA-Compliant AI Deployment",
    "Healthcare Workflow Automation",
    "Enterprise AI Platforms",
    "Clinical AI Systems",
  ],
};
